// Action types for Agent Scanners domain
// Following the same pattern as clientApplications/actionTypes.js

// List operations
export const FETCH_AGENT_SCANNER_LIST_REQUEST =
  'Fetch agent scanner list request';
export const FETCH_AGENT_SCANNER_LIST_SUCCESS =
  'Fetch agent scanner list success';
export const FETCH_AGENT_SCANNER_LIST_FAILURE =
  'Fetch agent scanner list failure';

// Create operations
export const CREATE_AGENT_SCANNER_SUCCESS = 'Create agent scanner success';

// Update operations
export const UPDATE_AGENT_SCANNER_SUCCESS = 'Update agent scanner success';

// Delete operations
export const DELETE_AGENT_SCANNER_REQUEST = 'Delete agent scanner request';
export const DELETE_AGENT_SCANNER_SUCCESS = 'Delete agent scanner success';
export const DELETE_AGENT_SCANNER_FAILURE = 'Delete agent scanner failure';

// Scanner runs (history) operations
export const FETCH_SCANNER_RUNS_REQUEST = 'Fetch scanner runs request';
export const FETCH_SCANNER_RUNS_SUCCESS = 'Fetch scanner runs success';
export const FETCH_SCANNER_RUNS_FAILURE = 'Fetch scanner runs failure';
export const CLEAR_SCANNER_RUNS = 'Clear scanner runs';

export const FETCH_STAGIN_AGENTS_REQUEST = 'Fetch stagin agents request';
export const FETCH_STAGIN_AGENTS_SUCCESS = 'Fetch stagin agents success';
export const FETCH_STAGIN_AGENTS_FAILURE = 'Fetch stagin agents failure';

export const RUN_SCAN_CONFIG_REQUEST = 'Run scan configuration request';
